import theme from 'antd/es/theme';
const { getDesignToken } = theme;

export const globalToken = getDesignToken();

export const breakpoints = {
  mobile: 700,
  tablet: 1024,
  desktop: 1600,
};

export const mq = (
  from?: number,
  until?: number,
  vertical?: boolean,
): string => {
  const isBetween = from && until;

  const size = vertical ? 'height' : 'width';

  return isBetween
    ? `@media (min-${size}: ${from}px) and (max-${size}: calc(${until}px + 0.02px))`
    : `@media (${from ? 'min' : 'max'}-${size}: ${from || until}px)`;
};

export const THEME_COLORS = [
  {
    id: 'blue',
    hex: '#1890ff',
  },
  {
    id: 'cyan',
    hex: '#13c2c2',
  },
  {
    id: 'geek-blue',
    hex: '#2f54eb',
  },
  {
    id: 'gold',
    hex: '#faad14',
  },
  {
    id: 'lime',
    hex: '#a0d911',
  },
  {
    id: 'magenta',
    hex: '#eb2f96',
  },
  {
    id: 'orange',
    hex: '#fa8c16',
  },
  {
    id: 'polar-green',
    hex: '#52c41a',
  },
  {
    id: 'default',
    hex: '#722ed1',
  },
  {
    id: 'red',
    hex: '#f5222d',
  },
  {
    id: 'volcano',
    hex: '#fa541c',
  },
  {
    id: 'yellow',
    hex: '#fadb14',
  },
];
